import toArray from '@hydra/utils/toArray';

export const normalizeValues = (data, normalizedMaximum = 100) => {
  const max = Math.max.apply(null, toArray(data));
  if (max === 0) {
    return data;
  }

  const factor = normalizedMaximum / max;
  return data.map(item => item * factor);
};
